<form (ngSubmit)="submit(aeroForm)"
    #aeroForm="ngForm">
  <ng-content></ng-content>
  <div class="aero-button-group">

    <aero-button *ngIf="showCancelButton"
           label="{{ 'cancelButton' | transloco }}"
           [size]="buttonSize"
           (onClick)="cancel()"
           [aeroStyle]="cancelButtonStyle">
    </aero-button>

    <aero-button *ngIf="showSubmitButton"
           [label]="submitButtonLabel"
           [disabled]="saveButtonDisabled"
           [size]="buttonSize"
           [aeroStyle]="buttonStyle"
           type="submit">
    </aero-button>
  </div>
</form>
